import { Action } from "redux";
import { User } from "_types/system";

export interface SystemState {
    user: null | User;
}

export const LOG_IN = 'LOG_IN'
export const LOG_OUT = 'LOG_OUT'

export interface LogInAction extends Action {
  type: typeof LOG_IN;
  user: User;
}

export interface LogOutAction extends Action {
  type: typeof LOG_OUT;
}

export type SystemAction = LogInAction | LogOutAction;
